import { getToken, setToken, removeToken } from '@/utils/auth'
import http from '@/utils/http'


const getDefaultState = () => {
    return {
        token: getToken()
    }
}

const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    }
}

const actions = {
    // 用户登录
    login({ commit }, userInfo) {
        const { username, password } = userInfo
        return new Promise((resolve, reject) => {
            http.post('/admin/login', {
                username: username,
                password: password
            }).then(response => {
                const { data } = response
                // console.log(data)
                commit('SET_TOKEN', data)
                setToken(data)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 删除Token
    resetToken({ commit }) {
        return new Promise(resolve => {
            removeToken() // 必须先删掉Token
            commit('RESET_STATE')
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
